module.exports = __webpack_public_path__ + "img/Skirt-Front-B2-Db-Fb-Gb-Hc-Ia.ab75c94f.png";